import './card-links.scss';

import Component from '../../components/component/component';

const returnStringBasedOnIndex: (index: number) => string = (index: number): string => {
    switch (index) {
        case 0:
            return 'first';
        case 1:
            return 'second';
        case 2:
            return 'third';
    }
};

export default class CardLinks extends Component {
    static initSelector: string = '.card-links';

    cardsWrapper: JQuery;
    card: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.cardsWrapper = this.element.find('.card-links__cards');
        this.card = this.element.find('.card-links__card');
        this.init();
    }

    init(): void {
        this.card.on('mouseenter', this.onMouseEnter.bind(this));
        this.card.on('mouseleave', this.onMouseLeave.bind(this));
    }

    onMouseEnter(event: JQuery.MouseEnterEvent): void {
        const columnModifier: string = returnStringBasedOnIndex($(event.currentTarget).index());

        this.cardsWrapper.addClass(`is-hovering-${columnModifier}`);
    }

    onMouseLeave(): void {
        const columnModifier: string = returnStringBasedOnIndex($(event.currentTarget).index());

        this.cardsWrapper.removeClass(`is-hovering-${columnModifier}`);
    }
}
